import { gql } from "@apollo/client";

export const GET_MATCHES_FOR_CANDIDATE = gql`
  query GetMatchesForCandidate($id: Int!) {
    matches(candidateId: $id) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      items {
        id
        jobId
        candidateId
        feedback
        jobAgentStatus
        jobAgentExpectedFee
        jobAgentName
        jobAgentEmail
        jobAgentPhone
        jobAgentExpectedStartDate
        jobAgentExpectedSchedule
        jobAgentSettlementFee
        jobAgentSettlementSchedule
        candidateAgentStatus
        candidateAgentExpectedFee
        candidateAgentName
        candidateAgentEmail
        candidateAgentPhone
        candidateAgentExpectedStartDate
        candidateAgentExpectedSchedule
        candidateAgentSettlementFee
        candidateAgentSettlementSchedule
        currentStatus
        statusHistory {
          id
          status
          notes
          updatedAt
          updatedByName
        }
      }
    }
  }
`;

export const GET_MATCHES_FOR_ROLE = gql`
  query GetMatchesForRole($id: Int!) {
    matches(jobId: $id) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      items {
        id
        jobId
        candidateId
        feedback
        jobAgentStatus
        jobAgentExpectedFee
        jobAgentName
        jobAgentEmail
        jobAgentPhone
        jobAgentExpectedStartDate
        jobAgentExpectedSchedule
        jobAgentSettlementFee
        jobAgentSettlementSchedule
        candidateAgentStatus
        candidateAgentExpectedFee
        candidateAgentName
        candidateAgentEmail
        candidateAgentPhone
        candidateAgentExpectedStartDate
        candidateAgentExpectedSchedule
        candidateAgentSettlementFee
        candidateAgentSettlementSchedule
        currentStatus
        statusHistory {
          id
          status
          notes
          updatedAt
          updatedByName
        }
      }
  }
}
`;

export const GET_JOB_MATCHES = gql`
  query JobMatches($skip: Int, $take: Int, $order: [JobMatchSortInput!]) {
    jobMatches(skip: $skip, take: $take, order: $order) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      items {
        id
        jobId
        clientName
        jobTitle
        candidateJobTitle
        candidateIdealJobTitles
        jobAgentStatus
        candidateAgentStatus
        currentStatus
        currency
        createdAt
        updatedAt
        candidateLocation {
          localityId
          displayName
        }
        jobLocation {
          countryCode
          suburb
          state
          postCode
          displayName
          localityId
        }
      }
    }
  }
`;

export const GET_CANDIDATE_MATCHES = gql`
  query CandidateMatches($skip: Int, $take: Int, $order: [CandidateMatchSortInput!]) {
    candidateMatches(skip: $skip, take: $take, order: $order) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      items {
        id
        candidateId
        candidateName
        jobTitle
        candidateJobTitle
        candidateIdealJobTitles
        jobAgentStatus
        candidateAgentStatus
        currentStatus
        currency
        createdAt
        updatedAt
        jobLocation {
          countryCode
          suburb
          state
          postCode
          displayName
          localityId
        }
        candidateLocation {
          localityId
          displayName
        }
      }
    }
  }
`;

export const GET_MATCH = gql`
  query Match($id: String!) {
    match(id: $id) {
      id
      jobId
      candidateId
      jobAgentStatus
      candidateAgentStatus
      currentStatus
      feedback
      jobAgentExpectedFee
      jobAgentName
      jobAgentEmail
      jobAgentPhone
      jobAgentExpectedStartDate
      jobAgentExpectedSchedule
      jobAgentSettlementFee
      jobAgentSettlementSchedule
      candidateAgentExpectedFee
      candidateAgentName
      candidateAgentEmail
      candidateAgentPhone
      candidateAgentExpectedStartDate
      candidateAgentExpectedSchedule
      candidateAgentSettlementFee
      candidateAgentSettlementSchedule
      currency
      statusHistory {
        id
        status
        notes
        updatedAt
        updatedByName
      }
    }
  }
`;

export const GET_MATCH_DETAILS = gql`
  query MatchDetails($id: String!) {
    matchDetails(id: $id) {
      id
      jobId
      candidateId
      jobAgentStatus
      candidateAgentStatus
      currentStatus
      feedback
      jobAgentExpectedFee
      jobAgentName
      jobAgentEmail
      jobAgentPhone
      jobAgentExpectedStartDate
      jobAgentExpectedSchedule
      jobAgentSettlementFee
      jobAgentSettlementSchedule
      candidateAgentExpectedFee
      candidateAgentName
      candidateAgentEmail
      candidateAgentPhone
      candidateAgentExpectedStartDate
      candidateAgentExpectedSchedule
      candidateAgentSettlementFee
      candidateAgentSettlementSchedule
      currency
      createdAtUtc
      updatedAtUtc
      userSide

      # Job details (flattened in MatchDetailsPayload)
      jobTitle
      jobClientName
      jobSummary
      jobSalaryMin
      jobSalaryMax
      jobLocation {
        countryCode
        state
        postCode
        suburb
        localityId
        displayName
      }

      # Candidate details (flattened in MatchDetailsPayload)
      candidateName
      candidateJobTitle
      candidateIdealJobTitles
      candidateLocation {
        localityId
        displayName
      }

      # Status history
      statusHistory {
        id
        status
        notes
        updatedAt
        updatedByName
      }
    }
  }
`;
